import { dateComparator } from '@components/Sorting/Provider';
import { createBestItineraryData } from './createBestItineraryData';

const isOnlyTrain = (transportTypes) => {
  return transportTypes.every((transport) => transport === 'TRAIN');
};

const isOneWay = (legs) => {
  return legs.length === 1;
};

const EarliestItineraryBuilder = () => {
  let earliestPosition;
  let earliest = {
    legs: [
      {
        segments: [
          {
            departureDate: '3000-12-31T23:59:59+01:00',
          },
        ],
      },
    ],
  };
  return {
    add(itinerary, position) {
      if (
        isOneWay(itinerary.legs) &&
        isOnlyTrain(itinerary.transportTypes) &&
        dateComparator(itinerary, earliest) < 0
      ) {
        earliest = itinerary;
        earliestPosition = position;
      }
    },
    build() {
      return createBestItineraryData('earliest', earliest, earliestPosition);
    },
  };
};

export default EarliestItineraryBuilder;
